import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { runsListSearchSchema } from '~/features/catalog-enrichment/types/runs.types';

const RunsListPage = lazy(() => import('~/features/catalog-enrichment/pages/runs-list-page'));

/** Run list (P01). Tab, filters and page live in the URL so they survive Back and can be shared. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment/runs/')({
  validateSearch: runsListSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <RunsListPage />
    </Suspense>
  ),
});
